import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="text-white py-4 footer_wrapper" style={{background:'#5A7B5E'}}>
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              <li><button className="text-white-50 text-decoration-none border-0 bg-transparent p-0">About Us</button></li>
              <li><button className="text-white-50 text-decoration-none border-0 bg-transparent p-0">Home</button></li>
              <li><button className="text-white-50 text-decoration-none border-0 bg-transparent p-0">Facilities</button></li>
              <li><button className="text-white-50 text-decoration-none border-0 bg-transparent p-0">Contact Us</button></li>
            </ul>
          </div>
          <div className="col-md-3">
            <h6 className="fw-bold mb-3">Products</h6>
            <ul className="list-unstyled">
              <li><button className="text-white-50 text-decoration-none border-0 bg-transparent p-0">Field Crops</button></li>
              <li><button className="text-white-50 text-decoration-none border-0 bg-transparent p-0">Vegetables</button></li>
            </ul>
          </div>
          <div className="col-md-3">
            <h6 className="fw-bold mb-3">Get In Touch</h6>
            <p className="text-white-50 mb-0">
              101, MGR Estates, Dwarakapuri, Punjagutta, Hyderabad, Telangana 500082
            </p>
          </div>
          <div className="col-md-3">
            <h6 className="fw-bold mb-3">Contact Info</h6>
            <ul className="list-unstyled">
            <li className="text-white-50">Email: info@trimurti.in</li>
            <li className="text-white-50">Phone: +91 9393802802</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 